import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'
import { CurrencySignType, I18nService, LgType } from '../../../services/prod/i18n.service'
import { ServicesType } from '../bmcore-services-block.component'

@Component({
  selector: 'bmcore-service-item',
  templateUrl: './bmcore-service-item.component.html',
  styleUrls: ['./bmcore-service-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreServiceItemComponent implements OnInit {
  @Input() service: ServicesType

  lg: LgType
  currencySign: CurrencySignType

  constructor(private i18nService: I18nService) {}

  ngOnInit() {
    this.currencySign = this.i18nService.getCurrencySign()
    this.lg = this.i18nService.getLanguageForPage()
  }
}
